import { AssetPreviewTabActivitiesController } from './asset-preview-tab-activities.controller'

function assetPreviewTabActivities () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<'
    },
    templateUrl: '/core/directives/asset-preview-tab-activities/asset-preview-tab-activities.html?$$REVISION$$',
    controller: AssetPreviewTabActivitiesController
  }
}
export { assetPreviewTabActivities }
